export default __webpack_public_path__ + "static/media/img_3.6edcf2f0.jpeg";